/* This is generated code, don't alter */
var IfcRampTypeEnum;
(function (IfcRampTypeEnum) {
    IfcRampTypeEnum[IfcRampTypeEnum["STRAIGHT_RUN_RAMP"] = 0] = "STRAIGHT_RUN_RAMP";
    IfcRampTypeEnum[IfcRampTypeEnum["TWO_STRAIGHT_RUN_RAMP"] = 1] = "TWO_STRAIGHT_RUN_RAMP";
    IfcRampTypeEnum[IfcRampTypeEnum["QUARTER_TURN_RAMP"] = 2] = "QUARTER_TURN_RAMP";
    IfcRampTypeEnum[IfcRampTypeEnum["TWO_QUARTER_TURN_RAMP"] = 3] = "TWO_QUARTER_TURN_RAMP";
    IfcRampTypeEnum[IfcRampTypeEnum["HALF_TURN_RAMP"] = 4] = "HALF_TURN_RAMP";
    IfcRampTypeEnum[IfcRampTypeEnum["SPIRAL_RAMP"] = 5] = "SPIRAL_RAMP";
    IfcRampTypeEnum[IfcRampTypeEnum["USERDEFINED"] = 6] = "USERDEFINED";
    IfcRampTypeEnum[IfcRampTypeEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcRampTypeEnum || (IfcRampTypeEnum = {}));
const IfcRampTypeEnumCount = 8;
export { IfcRampTypeEnum, IfcRampTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcRampTypeEnum = new Int32Array([-2, 0, 7]);
let prefixSumAddressIfcRampTypeEnum = new Uint32Array([0, 13, 29, 42, 61, 73, 92, 115, 138]);
let slotMapIfcRampTypeEnum = new Int32Array([5, 4, 6, 0, 7, 2, 1, 3]);
let encodedDataIfcRampTypeEnum = (new TextEncoder()).encode(".SPIRAL_RAMP..HALF_TURN_RAMP..USERDEFINED..STRAIGHT_RUN_RAMP..NOTDEFINED..QUARTER_TURN_RAMP..TWO_STRAIGHT_RUN_RAMP..TWO_QUARTER_TURN_RAMP.");
let IfcRampTypeEnumSearch = new MinimalPerfectHash(gMapIfcRampTypeEnum, prefixSumAddressIfcRampTypeEnum, slotMapIfcRampTypeEnum, encodedDataIfcRampTypeEnum);
export { IfcRampTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcRampTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcRampTypeEnumSearch, input, cursor, endCursor);
}
